import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { PenLine } from "lucide-react";

interface Props {
  handleDetail: (id: number) => void;
  item: { id: number };
}

export const ZonalGrossMarginActions = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Editar</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <PenLine
          cursor="pointer"
          onClick={() => handleDetail(item.id)}
          data-testid="zonal-gross-margin-actions-edit"
        />
      </Flex>
    </Tooltip>
  );
};
